module.exports = __webpack_public_path__ + "cf468e52499241c87e3800d5b2b2eac3.svg";